// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { AiApiSpec_emptySchema } from './AiApiSpec_emptySchema';

export const AiApiSpec_addToPredictionsQueueQueryParamsSchema = z.object({
  tic_user_id: z.coerce.string(),
  timely_account_id: z.number(),
  consequential_change_at: z.optional(z.coerce.string()),
  timely_user_id: z.number().describe("The Timely `user.id` reference to the user, if known"),
  since: z.coerce.string(),
  to: z.optional(z.coerce.string()),
});

/**
 * @description 200 response
 */
export const AiApiSpec_addToPredictionsQueue200Schema = z.lazy(() => AiApiSpec_emptySchema);

export const AiApiSpec_addToPredictionsQueueQueryResponseSchema = z.lazy(() => AiApiSpec_addToPredictionsQueue200Schema);
